import React from "react";
import { Phone, Mail, User } from "lucide-react";
import { initials } from "@/lib/utils-app";

const ROLE_BADGE = {
  "sökande": "bg-blue-50 text-blue-700 border-blue-200",
  "handläggare": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "entreprenör": "bg-amber-50 text-amber-700 border-amber-200",
};

export default function ContactCard({ contact }) {
  const badge = ROLE_BADGE[contact.role] || "bg-zinc-100 text-zinc-700 border-zinc-200";
  return (
    <div
      data-testid={`contact-card-${contact.contact_id}`}
      className="bg-white border border-zinc-200 rounded-sm p-5 flex items-start gap-4 transition-all duration-200 hover:border-blue-400"
    >
      <div className="w-12 h-12 rounded-full bg-blue-700 text-white flex items-center justify-center font-semibold text-sm flex-shrink-0">
        {initials(contact.name)}
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="text-base font-medium text-zinc-900 truncate">{contact.name}</h4>
        {contact.company && <div className="text-sm text-zinc-500 truncate">{contact.company}</div>}
        <span className={`mt-2 inline-block text-xs font-semibold uppercase tracking-wider px-2 py-0.5 border rounded-sm ${badge}`}>
          {contact.role}
        </span>
        <div className="mt-3 flex flex-col gap-1 text-sm text-zinc-600">
          {contact.email && (
            <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-blue-700">
              <Mail className="w-3.5 h-3.5 stroke-[1.5]" /> {contact.email}
            </a>
          )}
          {contact.phone && (
            <a href={`tel:${contact.phone}`} className="flex items-center gap-2 hover:text-blue-700">
              <Phone className="w-3.5 h-3.5 stroke-[1.5]" /> {contact.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
